import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToiletFemaleinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 10,
			r: 5
		}), /* @__PURE__ */ _jsx("path", { d: "M30.333 19h3.334a2 2 0 0 1 1.846 1.23L45 43H19l9.487-22.77A2 2 0 0 1 30.333 19zm.327 40h2.68a2 2 0 0 0 1.966-1.631L38 43H26l2.694 14.369A2 2 0 0 0 30.66 59z" })]
	})
});
export default SvgToiletFemaleinline;
